import React from 'react';

interface ContentCopyIconProps {
  width?: number | string;
  height?: number | string;
  fill?: string;
  className?: string;
}

const ContentCopyIcon: React.FC<ContentCopyIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  className,
}) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" fill={fill} />
  </svg>
);

export default ContentCopyIcon;
